import React from "react";
import {
	StyleSheet,
	TouchableOpacity
} from "react-native";

import StyledText from "./StyledText";
import Style from "ae-style";
import StyledIcon from "./StyledIcon";

import { useIdPrefix } from "@aetonix/hooks";

const styles = StyleSheet.create({
	navBannerStyle: {
		flexDirection: "row",
		padding: Style.layout.paddingButton,
		alignItems: "center",
		backgroundColor: Style.colors.dark,
	},
	iconSpacing: {
		marginRight: Style.layout.marginSmall
	}
});

export default function NavBanner({ title, icon, onPress, id }){
	const idPrefix = useIdPrefix();

	return(
		<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${id}`} style={styles.navBannerStyle} onPress={onPress}>
			<StyledIcon contrast name={icon} style={styles.iconSpacing} />
			<StyledText testID={id + "_text"} contrast>{title}</StyledText>
		</TouchableOpacity>
	);
}